import React from 'react';
import PropTypes from 'prop-types';
import Profile from './Profile';
import Modal from './Modal';
import './ProfileSelectorModal.scss';

export default function ProfileSelectorModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      className="profile-selector-modal"
      showCloseButton
    >
      {/* Spreading props here ensures Profile.jsx receives 
        profiles, isLoadingProfiles, onSelectProfile, etc. 
      */}
      <Profile {...props} />
    </Modal>
  );
}

ProfileSelectorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoadingProfiles: PropTypes.bool.isRequired,
  isManagingProfiles: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
  // Ensure the profiles array is validated
  profiles: PropTypes.array
};
